<template>
  <form id="login" @submit.prevent="logIn">
    <h1 class="title">Entrar</h1>
    <p class="subtitle">
    </p>

    <alert-login-forbidden
      :forbidden-email="email"
      v-if="errors.forbidden"/>

    <div class="alert -success" v-if="registered">
      <p class="title">Verifique seu Email</p>
      <p>Seu cadastro foi realizado com sucesso, verifique sua caixa de email e clique no link de ativação.</p>
    </div>

    <div class="alert -danger" v-if="showDangerAlert">
      <p class="title">Ops!</p>

      <p>{{ textDangerAlert }}</p>
    </div>

    <div class="form-group" :class="{'-has-error': errors.email.length > 0}">
      <label for="email" class="label">E-mail</label>
      <input
        class="form-control"
        id="email"
        type="email"
        placeholder="Email"
        v-model="email"
        autocomplete
        required
      >
      <p class="description" v-if="errors.email.length > 0">{{ errors.email[0] }}</p>
    </div>
    <div class="form-group" :class="{'-has-error' : errors.password.length > 0}">
      <label for="password" class="label">
        Senha
        <router-link to="/forgot-password" class="helper">Esqueceu a senha?</router-link>
      </label>
      <input
        class="form-control"
        id="password"
        type="password"
        placeholder="******************"
        autocomplete
        v-model="password"
        required
      >
      <p class="description" v-if="errors.password.length > 0">{{ errors.password[0] }}</p>
    </div>

    <div class="actions">
      <button class="btn btn-primary" type="submit">
        Entrar
      </button>
    </div>

    <div class="callSignUp" v-if="dashboardConfig.auth.register">
      <p>Novo na plataforma? <router-link to="/register">Crie uma conta</router-link>.</p>
    </div>

    <loader
      background="#FFF"
      v-if="loading"/>
  </form>
</template>

<script>
import { mapState } from 'vuex';
import Loader from '@/support/components/Loader.vue';
import AlertLoginForbidden from '@/auth/components/AlertLoginForbidden.vue';
import checkErrorIsUnrecognizedResponse from '@/support/helpers/checkErrorIsUnrecognizedResponse';

export default {
  name: 'Login',

  props: {
    registered: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      email: '',
      password: '',

      loading: false,

      errors: {
        email: [],
        password: [],
        unauthorized: false,
        forbidden: false,
        unrecognized: false,
      },
    };
  },

  methods: {
    /**
     * LogIn the account.
     *
     * @returns {Promise<void>}
     */
    async logIn() {
      try {
        this.loading = true;
        this.resetErrors();

        const form = {
          email: this.email,
          password: this.password,
        };

        await this.$store.dispatch('auth/logIn', form);

        this.$router.push({ name: 'Home' });
      } catch (err) {
        if (checkErrorIsUnrecognizedResponse(err, [422, 401, 403])) {
          this.errors.unrecognized = true;

          return;
        }

        const { data, status } = err.response;

        if (status === 422) {
          this.errors.email = data.errors.email || [];
          this.errors.password = data.errors.password || [];
        }

        if (status === 401) {
          this.errors.unauthorized = true;
        }

        if (status === 403) {
          this.errors.forbidden = true;
        }
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the errors page.
     */
    resetErrors() {
      this.errors.email = [];
      this.errors.password = [];
      this.errors.unauthorized = false;
      this.errors.unrecognized = false;
      this.errors.forbidden = false;
    },
  },

  computed: {
    ...mapState('dashboard', [
      'dashboardConfig',
    ]),

    /**
     * Check if can show the danger alert. Will be true
     * if errors.unauthorized, errors.unrecognized, errors.forbidden or
     * $store.state.auth.accessTokenExpired are true.
     *
     * @returns {boolean}
     */
    showDangerAlert() {
      if (this.errors.unauthorized || this.errors.unrecognized) {
        return true;
      }

      if (this.$store.state.auth.accessTokenExpired) {
        return true;
      }

      return false;
    },

    /**
     * The text to show in the danger alert.
     *
     * @returns {string}
     */
    textDangerAlert() {
      if (this.errors.unauthorized) {
        return 'E-mail ou senha incorretos';
      }

      if (this.errors.unrecognized) {
        return 'Ocorreu um erro ao tentar fazer login, tente novamente';
      }

      if (this.$store.state.auth.accessTokenExpired) {
        return 'Sua sessão expirou, por favor faça login novamente';
      }

      return 'Erro desconhecido';
    },
  },

  components: {
    Loader,
    AlertLoginForbidden,
  },
};
</script>

<style lang="scss" scoped>
  #login {
    @apply relative;

    > .alert {
      @apply mb-4;
    }

    > .title {
      @apply text-xl;
      @apply font-bold;
      @apply text-secondary-700;
      letter-spacing: -0.01em;
      margin-bottom: 8px;
    }

    > .subtitle {
      @apply text-sm;
      @apply mb-5;
      @apply text-gray-800;
    }

    > .form-group {
      @apply mb-5;
    }

    > .actions {
      @apply mb-5;

      > .btn {
        @apply w-full;
      }
    }

    > .callSignUp {
      @apply text-sm;
      @apply mb-5;
      @apply text-gray-800;
    }
  }
</style>
